import React, {useEffect, useRef} from 'react';
import './ContextMenu.css'; // Стили для компонента

const ContextMenu = ({
  top,
  left,
  onEdit,
  onDuplicate,
  onArchive,
  onDelete,
  onClose,
}) => {
  const menuRef = useRef(null);
  useEffect(() => {
    // Функция, которая закрывает меню при клике вне его
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose(); // Закрыть меню
      }
    };

    // Добавляем обработчик кликов
    document.addEventListener('click', handleClickOutside);

    // Убираем обработчик при размонтировании компонента
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onClose]);
  return (
    <ul
      ref={menuRef}
      tabIndex='-1'
      role='menu'
      aria-hidden='false'
      className='context-menu'
      style={{top: `${top}px`, left: `${left}px`}}
    >
      <li
        className='context-menu__item'
        data-cy='Редактировать'
        onClick={onEdit}
      >
        <i className='context-menu__item-icon el-icon-edit'></i>
        Редактировать
      </li>
      <li
        className='context-menu__item'
        data-cy='Дублировать'
        onClick={onDuplicate}
      >
        <i className='context-menu__item-icon el-icon-copy-document'></i>
        Дублировать
      </li>
      <li className='context-menu__item' data-cy='В архив' onClick={onArchive}>
        <i className='context-menu__item-icon el-icon-s-cooperation'></i>В архив
      </li>
      <li className='context-menu__item' data-cy='Удалить' onClick={onDelete}>
        <i className='context-menu__item-icon el-icon-delete'></i>
        Удалить
      </li>
    </ul>
  );
};

export default ContextMenu;
